import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Pagination } from 'semantic-ui-react';
import NotificationList from '../index';

const NotificationPagination = ({
  notifications,
  pagination,
  handlePageChange,
}) => (
  <div className="container">
    <div className="notification-list-container bg-white mt-20">
      <Grid centered columns={3}>
        <Grid.Column>
          <div className="notification-list-pagination">
            {pagination && (
              <Pagination
                activePage={pagination.current_page}
                totalPages={pagination.total_pages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </Grid.Column>
      </Grid>
      <NotificationList notifications={notifications} screen />
      <Grid centered columns={3}>
        <Grid.Column>
          <div className="notification-list-pagination">
            {pagination && (
              <Pagination
                activePage={pagination.current_page}
                totalPages={pagination.total_pages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </Grid.Column>
      </Grid>
    </div>
  </div>
);

NotificationPagination.propTypes = {
  handlePageChange: PropTypes.func,
  notifications: PropTypes.array,
  pagination: PropTypes.object,
};

export default NotificationPagination;



// WEBPACK FOOTER //
// ./src/components/NotificationList/NotificationPagination/NotificationPagination.js